import Consent from './consent.vue';

export default Consent;
